import { Outlet } from "react-router-dom"
import { Layout } from "antd"
import Header from "./components/Header"
import Sidebar from "./components/Sidebar"
import useCollapse from "hooks/useCollapse"
import styled from "styled-components"

const ContentStyle = styled.div({
  padding: "8px",
  height: "100%",
  boxSizing: "border-box",
  overflow: "auto"
})

const { Content } = Layout

export default function MainLayout() {
  const { isCollapse, onToggle } = useCollapse()

  const handleCollapsed = () => {
    onToggle()
  }

  return (
    <Layout style={{ height: "100vh" }}>
      <Sidebar collapsed={isCollapse} />
      {/* minHeight: 0 on both flex containers below overrides the flexbox default of
          min-height: auto — without it, a page taller than the viewport (e.g. Import Trip's
          stacked cards) stretches Content to fit its content instead of scrolling internally,
          pushing this 100vh Layout taller than the viewport and scrolling the whole app shell
          (sidebar + header) with it. */}
      <Layout style={{ display: "flex", flexDirection: "column", minHeight: 0 }}>
        <Header collapsed={isCollapse} onCollapsed={handleCollapsed} />
        <Content style={{ flex: 1, overflow: "auto", minHeight: 0 }}>
          <ContentStyle>
            <Outlet />
          </ContentStyle>
        </Content>
      </Layout>
    </Layout>
  )
}
